import {
  prop, propOr, compose, filter, map, values,
} from 'ramda';
import { createSelector } from 'reselect';

import { RESERVE_SEAT } from '@ezugi/constants/gameSocketMessages';

import {
  filtersSelector,
  lobbyConfigSelector,
  excludedGamesSelector,
  excludedTablesSelector,
} from './config';
import { userSelector, authParamsSelector } from './user';

export const tablesSelector = (state) => state.tables;

export const favoriteSelector = createSelector(
  tablesSelector,
  compose(map(prop('tableId')), filter(prop('favorite')), values)
);

export const recentSelector = createSelector(
  tablesSelector,
  compose(map(prop('tableId')), filter(prop('recent')), values)
);

export const tableSelector = createSelector(
  tablesSelector,
  (_, id) => id,
  (tables, id) => tables[id]
);

export const hasHybridActiveSelector = createSelector(
  tablesSelector,
  (_, id) => id,
  (tables, id) => tables[id]?.active
);

export const reserveSeatSelector = createSelector(userSelector, (user) => ({
  BrandID: 0,
  PlayerId: user.uid,
  ClientIP: user.client_ip,
  clientType: 'html',
  MessageType: RESERVE_SEAT,
  OperatorID: user.operator_id,
  Nickname: user.nickname,
  destination: 'table',
}));

export const shouldShowRecommendedSelector = createSelector(
  lobbyConfigSelector,
  filtersSelector,
  authParamsSelector,
  (lobbyConfig, filters, authParams) => {
    // In case "enable_game_group_selector" is set to false AND
    // the player reached the lobby from a game_group link,
    // do not show the Ezugi recommended strip.
    if (
      (!lobbyConfig.enable_game_group_selector && !!authParams?.group)
      || !filters.ezugi_recommended_active
    ) return false;

    return true;
  }
);

export const recommendedTablesSelector = createSelector(
  filtersSelector,
  tablesSelector,
  favoriteSelector,
  excludedTablesSelector,
  excludedGamesSelector,
  (filters, tables, favoriteTables, excludedTables, excludedGames) => {
    const recommended = propOr([], 'recommended_tables')(filters);

    return recommended.filter(
      (tableId) => !excludedTables.includes(tableId)
        && !excludedGames.includes(tables[tableId]?.gameId)
        && !favoriteTables.includes(tableId)
    );
  }
);
